module.exports = __webpack_public_path__ + "static/media/slide2.78f2c03c.jpg";